import React from 'react';
import { useSelector } from 'react-redux';
import { DocumentId } from 'services/documents/types';
import { AppState } from 'services/types';
import { selectDocumentAssignedUsersList } from './selectors';

interface Props {
    documentId: DocumentId;
}

function DocumentAssignedUsersList({ documentId }: Props): React.ReactElement {
    const documentAssingedUsersList = useSelector((state: AppState) =>
        selectDocumentAssignedUsersList(state, { documentId })
    );

    return <span>{documentAssingedUsersList}</span>;
}

export default DocumentAssignedUsersList;
